import { render, staticRenderFns } from "./buildAddModule.vue?vue&type=template&id=c8d1118e&scoped=true"
import script from "./buildAddModule.vue?vue&type=script&lang=js"
export * from "./buildAddModule.vue?vue&type=script&lang=js"
import style0 from "./buildAddModule.vue?vue&type=style&index=0&id=c8d1118e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d1118e",
  null
  
)

export default component.exports